import React from 'react';

import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as ls from "./_csLcl";
import { a } from "./_csAbt";

import * as BtnC from './_cccBtnC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";

import * as ica from 'src/ica';
import * as _cv_60 from './_cv_60___Mz';

let $_60rs = [] as ht.ls;

import * as BtnTopC from './_ccmBtnTopC';
export const B = (pz: ht.btnTopCz) => {
  return (
    cr.c(BtnTopC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
      }
    })
  )
};

export const L = (pz: ht.viewListCz) => {

  React.useEffect(() => {
    f.loadAllAsync({
      frcUdt: pz.sPz.udt,
      bfrAsync: () => [
        _cv_60.load_60rLsAsync()
        .then((_ls: ht.ls) => {
          $_60rs = _ls
        })
      ]
    })
  }, []);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewListAbtz[_abtType] ? ica.viewListAbtz[_abtType]() : {};

  const _hdrs = [];
  const _cellCs = [
    {
      //boxStlz: a('f/0.25'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '対象年',
            stlz: a(`tc/${pz.cz.ccd}7`)
          }
        })
      ]
    },
  ];
  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  //hf.l(`_cv_60a 64: ${hf.s($_60rs)}`);
  const _rows = [] as ht.ls;
  $_60rs?.map( ( _dz: ht.dz ) => {
    const _cellCs = [
      {
        //boxStlz: a('f/0.25'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _dz._icn,
            }
          })
        ]
      },
      {
        boxStlz: a('dw/10 f/n'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            ... _abtz.bdyCz.btnCz,
            boxStlz: a(`sc/${pz.cz.ccd}5`),
            lblCz: {},
            pslPtyz: {
              onPress: () => {
                pz.sPz.set({
                  steps: [1],
                  phs: 'dpy',
                  _60r_fst: _dz._fst,
                })
              }
            },
          })
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cellCs
      },
    )
  });

  return (
    cr.c(TblC.N, {
      key: -30,
      ... _abtz.tblCz,
      srlCz: {
        srlStlz: {
          otrz: a('dwx/60'),
        },
      },
      hdrCz: {
        boxStlz: a(`bc/${pz.cz.ccd}7`),
        lineCs: _hdrs,
      },
      bdyCz: {
        boxStlz: a(`bc/${pz.cz.ccd}7`),
        lineCs: _rows,
      },
    })
  );
};

